import "./News.css";

const NewsGridItem = ({ article }) => {
  const fallbackImage = "../../../assets/photos/newsunaivalble.png";

  return (
    <div
      className="gridItem"
      onClick={() => {
        window.open(article.link, "_blank", "noopener,noreferrer");
      }}>
      {article.imageUrl && (
        <img
          src={article.imageUrl}
          alt={article.title}
          className="newsImage"
          onError={(e) => {
            e.target.onerror = null; // prevent infinite loop
            e.target.src = fallbackImage;
          }}
        />
      )}

      <p className="NewsTitle">{article.title}</p>

      <p className="NewsDesc">{article.description}</p>
      <p className="pubDate">{article.pubDate}</p>
    </div>
  );
};

export default NewsGridItem;
